export const environment = {
    production: false,
    apiUrl: 'https://web.api.dev.takenote.cloud',
    originatorId: 'travelex-dev-originator',
    firebaseConfig: { 
        projectId: "cc-payavon-demo",
        appId: "1:598628678213:web:bf84aed654986b864a012c",
        storageBucket: "cc-payavon-demo.firebasestorage.app",
        apiKey: "AIzaSyBS9EPDBnh7VJBk8JtjOhs_mQtxrH-l3Yw",
        authDomain: "cc-payavon-demo.firebaseapp.com",
        messagingSenderId: "598628678213",
        measurementId: "G-G0P318D3T4" 
      },
    analyticsDebugMode: true
};